import { createAction, props } from '@ngrx/store';

import { RocSection } from '@main-application/dashboard-reports/roc-report/interfaces/roc-list-item';
import { SortItem } from '@shared/interfaces/sort-item';
import { RestTurnoverTaskModel } from '@shared/interfaces/turnover.interface';

export const loadRocReport = createAction('[Roc] Load Roc report', props<{ portfolioId: number }>());
export const loadRocReportSuccess = createAction('[Roc] Set Roc report', props<{ report: RestTurnoverTaskModel[] }>());
export const loadRocReportError = createAction('[Roc] Error Roc report');
export const setRocSorting = createAction('[Roc] set Roc sorting', props<{ propertyId: number; sorting: SortItem }>());

export const setDisplayedRocSections = createAction(
  '[Roc] setDisplayedRocItems',
  props<{ displayedSections: RocSection[] }>()
);

export const updateMarketRent = createAction(
  '[Roc] updateMarketRent',
  props<{ portfolioId: number; propertyId: number; turnoverId: number; value: number }>()
);

export const updateMarketRentSuccess = createAction(
  '[Roc] updateMarketRentSuccess',
  props<{ turnoverId: number; value: number }>()
);

export const updateConstructionCost = createAction(
  '[Roc] updateConstructionCost',
  props<{ portfolioId: number; propertyId: number; turnoverId: number; value: number }>()
);

export const updateConstructionCostSuccess = createAction(
  '[Roc] updateConstructionCostSuccess',
  props<{ turnoverId: number; value: number }>()
);

export const updateNewRent = createAction(
  '[Roc] updateNewRent',
  props<{ portfolioId: number; propertyId: number; turnoverId: number; value: number }>()
);

export const updateNewRentSuccess = createAction(
  '[Roc] updateNewRentSuccess',
  props<{ turnoverId: number; value: number }>()
);

export const updateOldRent = createAction(
  '[Roc] updateOldRent',
  props<{ portfolioId: number; propertyId: number; turnoverId: number; value: number }>()
);

export const updateOldRentSuccess = createAction(
  '[Roc] updateOldRentSuccess',
  props<{ turnoverId: number; value: number }>()
);
